// import { register } from '@/module/Register/locale/register.th.js';
// base
import { date } from '@/helper/locale/base/base_date.en.js';
import { button } from '@/helper/locale/base/base_button.en.js';
// module
import { collect_point } from '@/module/CollectPoint/locale/collectpoint.en.js';
import { home } from '@/module/Home/locale/home.th.js';
import { register } from '@/module/Register/locale/register.th.js';
import { profile } from '@/module/Profile/locale/profile.th.js';
import { transfer } from '@/module/TransferPoint/locale/transfer.th.js';
import { contactus } from '@/module/ContactUs/locale/contactUs.th.js';
import { forgetpassword } from '@/module/ForgetPassword/locale/forgetpassword.th.js';
import { TransferMAAI } from '@/module/TransferMAAI/locale/TransferMAAI.th.js';

export const th = {
    // base
    date,
    button,
    // module
    collect_point,

    home: home,
    profile: profile,
    register: register,
    transfer,
    contactus,
    forgetpassword,
    TransferMAAI: TransferMAAI,

    commonLbl:{
        profile: 'โปรไฟล์',
        logout: 'ออกจากระบบ',
    },

    otp: {
        headline: 'ยืนยันตัวตนผ่านรหัส OTP',
        contact_number_lbl: 'OTP ส่งไปยัง',
        refcode_lbl: 'รหัสอ้างอิง: ',
        timeleft: 'รหัสจะหมดอายุภายใน ',
        resend_otp: 'ส่งรหัสอีกครั้ง',
        ok_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',
        otp_incorrect: "คุณกรอกรหัส OTP ไม่ถูกต้องกรุณาตรวจสอบอีกครั้ง",
        confirm: "ยืนยัน"
    },

    confirm_redeem: {
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",

        headline: 'ยืนยัน',
        headline2: 'ยืนยันการแลกสิทธิพิเศษ ?',
        default_text: 'คุณต้องการใช้',
        to_redeem: 'ในการแลก',
        this_reward: 'สิทธิพิเศษนี้ใช่หรือไม่',
        default: 'ยืนยันการรับสิทธิ์',
        defualt_have_time: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        free_no_timer: 'ยืนยันการรับสิทธิ์',
        free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
        draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        deal_no_timer: 'ยืนยันการรับสิทธิ์',
        deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        buy: 'ยืนยันการซื้อ',
        buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        interface: 'ยืนยันเพื่อเข้าสู่เว็บไซต์ที่ร่วมรายการ',
    },
    redeem_button: {
        default: 'กดรับสิทธิ์',
        none: '',
        soldOut: 'มีผู้แลกสิทธิพิเศษครบจำนวนสิทธิ์',
        soldOutBuy: 'มีผู้แลกสิทธิพิเศษครบจำนวนสิทธิ์',
        maxPerPerson: 'แลกสิทธิพิเศษแล้ว',
        redeemCoolDown: 'ขออภัย คุณได้รับ Campaign นี้ไปแล้ว กรุณารอกดรับใหม่อีกครั้งภายหลัง',
        nextDate: 'รับสิทธิ์ครั้งต่อไปได้<br/>ตั้งแต่ : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'คุณต้องทำตามเงื่อนไขที่ระบุไว้ใน Campaign นี้ก่อนจึงสามารถกดรับได้ กรุณาอ่านเพิ่มเติมในรายละเอียด',
        campaignExpired: 'สินค้านี้หมดอายุแล้ว',
        campaignExpiredBuy: 'สินค้านี้หมดอายุแล้ว',
        campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
        notEnoughPoint: 'ขออภัยคะแนนของคุณไม่พอ',
        notSupport: 'ไม่รองรับแคมเปญประเภทนี้',
        notMAAIMember: 'ไม่ได้เป็นสมาชิก MAAI',
    },
    purchase: {
        show_code: 'กดเพื่อดูรหัส',
        code_expired: 'รหัสหมดอายุ',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',
        shipped: 'สินค้าได้ถูกจัดส่งเรียบร้อยแล้ว',
        parcel_no: 'พัสดุเลขที่',

        not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
        not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',
        draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',
        draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีได้รับของรางวัลนี้',
        draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',
        parcelNo: 'หมายเลขพัสดุ',
        status: 'สถานะ',
        privilege_shipped_fail: "จัดส่งไม่สำเร็จ",
        privilege_shipped: 'จัดส่งสำเร็จ',
        privilege_delivery: 'อยู่ระหว่างจัดส่ง',
        privilege_prepare: 'เตรียมจัดส่ง',
    },
    serial: {
        close_btn: 'ปิด',
        default_privilege_message: 'ตามดีไซน์',
        show_code_at_shop: 'กรุณาแสดงรหัสนี้ ให้แก่ร้านค้า',
        show_code: 'กรุณาแสดงรหัสนี้แก่พนักงาน',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',

        draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล หลังจากวันที่ {0}',
        draw_after: 'หลังจากวันที่',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        copy_code: 'คัดลอก',

        expire_in: 'รหัสหมดอายุใน : ',
        code_expired: 'รหัสหมดอายุ',

        redeem_on: 'รับสิทธิ์เมื่อ {0}',
        use_on: 'ใช้เมื่อ : ',

        slide_to_unmask: 'เลื่อนเพื่อใช้รหัส',
        Used: "ใช้แล้ว",
        copy: 'คัดลอก',
        isUsed: 'ใช้งานแล้ว',
        isExpired: 'หมดอายุ',

    },
    shipping: {
        headline: 'ที่อยู่จัดส่ง',
        title: 'ที่อยู่จัดส่ง',
        firstname: {
            name: 'ชื่อจริง',
            placeholder: 'ชื่อจริง',
            required: 'กรุณากรอกชื่อจริง',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        addressName: {
            name: 'ชื่อที่อยู่',
            placeholder: 'ชื่อที่อยู่',
            required: 'กรุณากรอกชื่อที่อยู่',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'ที่อยู่',
            placeholder: 'กรุณากรอกที่อยู่',
            required: 'กรุณากรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'เบอร์โทรศัพท์',
            placeholder: 'เบอร์โทรศัพท์',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
            invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        },
        nationalid: {
            name: 'เลขประจำตัวประชาชน',
            placeholder: 'เลขประจำตัวประชาชน',
            required: 'กรุณากรอกเลขประจำตัวประชาชน',
            too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
            invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: 'กรุณากรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'แขวง/ตำบล',
            placeholder: 'กรุณาเลือกแขวง/ตำบล',
            required: 'กรุณาเลือกแขวง/ตำบล',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'เขต/อำเภอ',
            placeholder: 'กรุณาเลือกเขต/อำเภอ',
            required: 'กรุณาเลือกเขต/อำเภอ',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'กรุณาเลือกจังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },

        isDefaultAddress: 'ตั้งเป็นที่อยู่หลัก',
        defaultAddress: 'ที่อยู่หลัก',
        save_address: 'บันทึกที่อยู่เพื่อใช้รับสิทธิ์ครั้งต่อไป',
        save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

        confirm_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',

        alert_headline: 'ที่อยู่จัดส่ง',
        alert_ok_btn: 'ตกลง',
    },
    tax: {
        personType: {
            name: 'ออกในนาม',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        title: {
            name: 'คำนำหน้าชื่อ',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        companyName: {
            name: 'ชื่อ / บริษัท',
            placeholder: 'ชื่อ / บริษัท',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        building: {
            name: 'อาคาร',
            placeholder: 'อาคาร',
            required: '',
            too_short: '',
            invalid: '',
        },
        room: {
            name: 'เลขที่ห้อง',
            placeholder: 'เลขที่ห้อง',
            required: '',
            too_short: '',
            invalid: '',
        },
        floor: {
            name: 'ชั้นที่',
            placeholder: 'ชั้นที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        village: {
            name: 'หมู่บ้าน',
            placeholder: 'หมู่บ้าน',
            required: '',
            too_short: '',
            invalid: '',
        },
        number: {
            name: 'เลขที่',
            placeholder: 'เลขที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        moo: {
            name: 'หมู่ที่',
            placeholder: 'หมู่ที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        soi: {
            name: 'ซอย',
            placeholder: 'ซอย',
            required: '',
            too_short: '',
            invalid: '',
        },
        road: {
            name: 'ถนน',
            placeholder: 'ถนน',
            required: '',
            too_short: '',
            invalid: '',
        },
    },
    main: {
        home_page: "หน้าแรก",
        login: "เข้าสู่ระบบ",
        campaign: "แคมเปญ",
        category: 'หมวดหมู่',
        map: "แผนที่",
        terms: "Terms And Conditions",
        history: 'ประวัติรับสิทธิ์',
        profile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        lang: "ภาษา",
        msgLogout: "ต้องการออกจากระบบ",
        cancel: "ยกเลิก",
    },
    campaign: {
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
        get: 'ได้รับ',
        use: 'ใช้',
    },
    detail: {
        detail: 'รายละเอียด',
        condition: 'เงื่อนไข',

        point_unit: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้ ',
        available_date: 'แลกได้วันที่',
        expire_date: 'วันหมดอายุ : {0}',

        color: {
            name: 'สี',
            placeholder: 'กรุณาเลือกสี',
            required: 'กรุณาเลือกสี',
        },
        size: {
            name: 'ขนาด',
            placeholder: 'กรุณาเลือกขนาด',
            required: 'กรุณาเลือกขนาด',
        },
        success_modal: {
            title: 'คุณได้ทำการแลกรับสิทธิพิเศษ <br> และกรอกข้อมูลจัดส่งสำเร็จ',
            redeem_date: 'วันที่รับสิทธิ์ : ',
            my_reward: 'สิทธิพิเศษของฉัน',
            more_reward: 'แลกสิทธิพิเศษเพิ่มเติม'
        }
    },
    history: {
        title: 'ประวัติคะแนน',
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
        earn_tab: 'การได้รับ',
        burn_tab: 'การใช้',
        tranfer_tab: 'โอนคะแนน',
        expire: 'หมดอายุ',
        show_code: 'กดเพื่อใช้รหัส', //'กดเพื่อใช้สิทธิ์', 
        earn_coin_from: "ได้รับการโอน Coin จากหมายเลข",
        transfer_coin_from: "โอน Coin ไปยังหมายเลข",
        nodata: 'ไม่มีข้อมูล',

        parcel_number: 'เลขพัสดุ : ',
        datePicker: {
            name: 'วันที่',
            placeholder: 'วันที่',
            required: '',
            too_short: '',
            invalid: '',
            date: {
                name: '',
                placeholder: 'Day',
                required: ' '
            },
            month: {
                name: '',
                placeholder: 'Month',
                required: ' '
            },
            year: {
                name: '',
                placeholder: 'Year',
                required: ' '
            },
        },
    },
    day: {
        mon: 'จ.',
        tue: 'อ.',
        wed: 'พ.',
        thu: 'พฤ.',
        fri: 'ศ.',
        sat: 'ส..',
        sun: 'อา',
    },
    terms: {
        accept: 'ยอมรับ',
        not_accept: 'ไม่ยอมรับ',
    },
    login: {
        register_login: 'ลงทะเบียน/เข้าสู่ระบบ',
    },
    bottom_bar: {
        home: 'หน้าหลัก',
        reward: 'สิทธิพิเศษ',
        mission: 'ภารกิจ',
        profile: 'โปรไฟล์',
    },
    topbar: {
        coin: 'คุณมี',
        call_center: 'โทรสายด่วน',
    },
    getfriend: {
        title: "รายละเอียดกิจกรรม",
        register_done: 'ลงทะเบียนสำเร็จแล้ว ',
        person: 'คน',
        fill_mobile: 'กรอกเบอร์โทรศัพท์ของเพื่อน',
        invitations: 'กรอกได้สูงสุดครั้งละ 10 หมายเลข',
        contact_number: 'เบอร์โทรศัพท์',
        enter_contact: 'กรอกเบอร์โทรศัพท์',
        more_input: 'เพิ่มช่องกรอก',
        confirm_sms: 'ยืนยันการส่งข้อความ',
        invite_success: 'ชวนเพื่อนสำเร็จ',
        congratulation: 'ยินดีด้วย !',
        invite_full: 'คุณชวนเพื่อนมาลงทะเบียนครบ 10 คนแล้ว',

        invite_friend: 'ชวนเพื่อนผ่านไลน์',
        checkin_success: 'เช็คอินสำเร็จ',
        event_description: 'รายละเอียดกิจกรรม',
        invite_friend_sms: 'ชวนเพื่อนผ่าน SMS',
        friend_get_friend: 'ชวนเพื่อนรับคะแนนเพิ่ม',
        invite_detail: 'ชวนเพื่อนครบ 10 คน รับคะแนนพิเศษฟรี!',
        checkin: 'เช็คอินวันนี้',
        checkedin: 'วันนี้เช็คอินแล้ว'
    }

};
